"use strict";

import angular from "angular";
/**
 * @component NuDataDescription
 * O <nu-data-description> è um componente que é usado para mostrar uma descrição de algo
 */

import template from "./data-description.component.html";
import "./data-description.component.scss";

const name = "nuDataDescription";
const def = {
    factory: [
        function () {
            return {
                restrict: "E",
                scope: {
                    description: "="
                },
                template
            };

        }
    ]
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
